import React from 'react';

/**
 * La marca de Lucifer: «quatre futurs».
 *
 * Quatre possibilitats en una graella 2×2 i una de triada, que és el que fa
 * l'aplicació —dos drivers creuats donen quatre escenaris i se n'escull un—.
 * És abstracta a posta: dibuixada amb cercles plens i buits, aguanta sencera a
 * 16 píxels, que és la mida real de la pestanya del navegador. Les marques amb
 * traços fins o corbes que es toquen s'hi desfan.
 *
 * El color surt de `currentColor`, o sigui que la marca l'hereta de qui la
 * conté: així només hi ha un lloc on canviar-lo i no hi ha cap color clavat
 * aquí dins. Als dos llocs on s'usa és `text-accent-700`, l'únic accent del
 * sistema de disseny (vegeu tailwind.config.js).
 *
 * El favicon és aquesta mateixa figura, a public/favicon.svg i favicon.ico.
 * Si algun dia la canvies, canvia'ls tots tres.
 */
const Logo = ({ size = 32, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    className={className}
    role="img"
    aria-label="Lucifer"
  >
    <circle cx="20" cy="20" r="7" fill="none" stroke="currentColor" strokeWidth="5" />
    <circle cx="44" cy="20" r="11" fill="currentColor" />
    <circle cx="20" cy="44" r="7" fill="none" stroke="currentColor" strokeWidth="5" />
    <circle cx="44" cy="44" r="7" fill="none" stroke="currentColor" strokeWidth="5" />
  </svg>
);

export default Logo;
